"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Layer = _interopRequireDefault(require("./Layer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };

    return extendStatics(d, b);
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __spreadArrays = void 0 && (void 0).__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;

  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];

  return r;
};
/* eslint-disable spaced-comment */
///<reference path="../../../../../../node_modules/@types/leaflet/index.d.ts" />

/* eslint-enable spaced-comment */


var LeafletPolygonLayer =
/** @class */
function (_super) {
  __extends(LeafletPolygonLayer, _super);

  function LeafletPolygonLayer(layer, polygons, opts, id) {
    if (opts === void 0) {
      opts = undefined;
    }

    if (id === void 0) {
      id = undefined;
    }

    var _this = _super.call(this, layer, opts, id) || this;

    _this._polygons = polygons;
    return _this;
  }

  LeafletPolygonLayer.prototype.setOpacity = function (value) {
    _super.prototype.setOpacity.call(this, value);

    if (this.renderable) {
      this.renderable.setStyle(__assign(__assign({}, this.opts), {
        fillOpacity: value
      }));
    }
  };

  LeafletPolygonLayer.prototype.createRenderable = function () {
    var _this = this;

    var groups = []; // need to combine all polygon coordinate paths into a single grouped array for the multi
    // polygon layer

    this._polygons.forEach(function (shape) {
      var outer = shape.outer;
      var inner = shape.inner ? shape.inner : [];
      groups.push(__spreadArrays([outer], inner));
    });

    var renderable = L.polygon(groups, this.opts);
    renderable.on('click', function (e) {
      _this.trigger('click', {
        polygon: _this
      });
    });
    return renderable;
  };

  return LeafletPolygonLayer;
}(_Layer.default);

var _default = LeafletPolygonLayer;
exports.default = _default;
module.exports = exports.default;